/**
 * Spatial Transition — Shared constants for iOS 26-style push transitions.
 *
 * Used by both SpatialOverlay (tab-level) and stackTransitionPlugin (Stackflow).
 * Change a value here → both update.
 */

// ── Feature flags ──
export const ENABLE_SCRIM_BLUR = false;

// ── Spatial Layering geometry ──
export const PARENT_X_RATIO = 0.15; // 15% parallax offset
export const PARENT_RADIUS = 38; // Parent corner rounding when receded
export const CHILD_RADIUS = 44; // Child corner rounding when lifted

// ── Gesture ──
export const EDGE_ZONE = 30; // px from screen edge to start swipe
export const THRESHOLD_RATIO = 0.3; // 30% drag = commit to pop
export const VELOCITY_THRESHOLD = 500; // px/s flick to pop

// ── Timing ──
export const DURATION_PUSH = 0.35;
export const DURATION_CLOSE = 0.25;
export const DURATION_REBOUND = 0.3;

// ── Eases ──
export const EASE_PUSH = 'back.out(0.7)';
export const EASE_SCRIM = 'power2.out';
export const EASE_CLOSE = 'power3.out';
export const EASE_REBOUND = 'back.out(1.7)';

// ── Scrim ──
export const SCRIM_COLOR = 'rgba(0, 0, 0, 0.15)';

// ── Helpers ──

/** Is the document in RTL mode? */
export function getIsRTL(): boolean {
  return typeof document !== 'undefined'
    ? document.documentElement.dir === 'rtl'
    : false;
}

/** Did the touch start within the edge swipe zone? */
export function isInEdgeZone(clientX: number, screenWidth: number, isRTL: boolean): boolean {
  return isRTL
    ? clientX > screenWidth - EDGE_ZONE
    : clientX < EDGE_ZONE;
}

/** Extract clientX from a press event (touch or pointer). */
export function getClientX(evt: Event): number {
  if (evt instanceof TouchEvent && evt.touches[0]) {
    return evt.touches[0].clientX;
  }
  if ('clientX' in evt) {
    return (evt as PointerEvent).clientX;
  }
  return 0;
}
